import React, { Component } from "react"
import { Formik, Field, Form } from "formik"
import contractFields from "models/contract"
import DateField from "components/DateField"
import fieldStatus from "helpers/fieldStatus"
import NumberField from "components/NumberField"
import * as Yup from "yup"
import submitData from "helpers/submitData"
import Typeahead from "components/Typeahead"
import TextArea from "components/TextArea"
import ReactSelect from "components/ReactSelect"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"
import _ from "lodash"
import currentUser from "helpers/currentUser"
import getData from "helpers/submitData"
import matchModel from "helpers/matchModel"
import settings from "settings"
import Modal from "react-responsive-modal"
import moment from "moment"
import classNames from "classnames"

class ContractModal extends Component {
	constructor(props) {
		super(props)
		let c = _.cloneDeep(props)
		// This logic checks if a start has already been entered and fills in that data for them.
		if (c.super) {
			_.forEach(c.data.lot, (v, k) => {
				if (contractFields.hasOwnProperty(k)) {
					contractFields[k] = c.data.lot[k]
				}
			})
		} else {
			_.forEach(c.data, (v, k) => {
				if (contractFields.hasOwnProperty(k)) {
					contractFields[k] = c.data[k]
				}
			})
		}
		// This modal may have developer (or property) specific fields, so add them to the model
		if (settings.additionalContractFields) {
			if (settings.additionalContractFields.global) {
				_.forEach(settings.additionalContractFields.global, (v) => {
					contractFields[v.name] = ""
				})
			}
			if (settings.additionalContractFields.communitySpecific[this.props.data.property]) {
				_.forEach(settings.additionalContractFields.communitySpecific[this.props.data.property], (v) => {
					contractFields[v.name] = ""
				})
			}
		}

		if (settings.requireContractZip) {
			contractFields.buyer_zip = ""
		}

		this.state = {
			fields: contractFields,
			trecModal: false,
			license: false,
			duplicateLicense: false, // if the realtor and license number are the same, show a warning.
			extraFields: {
				brokerage: {
					teams: [],
					offices: [],
				},
			},
			data: {
				address: "",
			},
			needRealtorData: false,
		}
	}

	componentDidMount() {
		if (_.get(this.props, `data.reserve_start_date`)) {
			getData("mainRetrieve", {
				action: "getBuyerPost",
				id: this.props.data.buyer_id,
			})
				.then((resp) => {
					let fields = _.cloneDeep(this.state.fields)
					let { primary_first, primary_last, co_first, co_last, has_co, primary_email } = resp.data
					fields.primary_first = primary_first
					fields.primary_last = primary_last
					fields.primary_email = primary_email
					fields.co_first = co_first
					fields.co_last = co_last
					fields.has_co = has_co
					this.setState({ fields }, () => {
						console.log(this.state)
					})
				})
				.catch((e) => {
					console.log(e)
				})
		}
	}

	validation = () => {
		if (this.props.super) {
			return Yup.object().shape({
				price: Yup.number()
					.min(100000, "Price must be at least $100,000.")
					.max(5000000, "Price must be below $5,000,000")
					.typeError("Please enter a valid price.")
					.required("Required"),
				sale_date: Yup.number()
					.moreThan(0, "Please enter a contract date.")
					.required("Required")
					.typeError("Please enter a contract date."),
			})
		} else {
			let shape = {
				salesperson: Yup.number().typeError('Required').required("Required"),
				floorplan: Yup.number("Start typing to choose a floorplan from the list.")
					.positive("Start typing to choose a floorplan from the list.")
					.typeError("Please enter a value.")
					.required("Start typing to choose a floorplan from the list."),
				price: Yup.number()
					.min(100000, "Price must be at least $100,000.")
					.max(5000000, "Price must be below $5,000,000")
					.typeError("Please enter a valid price.")
					.required("Required"),
				sqft: Yup.number()
					.min(500, "Square feet must be at least 500.")
					.max(25000, "Square feet maximum must be below 25,000")
					.typeError("Please enter a value.")
					.required("Required"),
				primary_first: Yup.string().min(2, "Must be longer than 2 characters").typeError('Required').required("Required"),
				primary_last: Yup.string().min(2, "Must be longer than 2 characters").typeError('Required').required("Required"),
				primary_email: settings.requireSaleEmail
					? Yup.string().email("Invalid email address").required("Required")
					: Yup.mixed().notRequired(),
				has_co: Yup.boolean(),
				co_first: Yup.string().when("has_co", {
					is: true,
					then: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				co_last: Yup.string().when("has_co", {
					is: true,
					then: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				realtor_involved: Yup.number().required("Required"),
				sale_date: Yup.number()
					.moreThan(0, "Please enter a contract date.")
					.required("Required")
					.typeError("Please enter a contract date."),
				estimated_closing: Yup.number()
					.moreThan(0, "Please choose a date from the calendar.")
					.moreThan(Yup.ref("sale_date"), "Estimated Closing Date should be after Sale Date.")
					.typeError("Please enter an estimated closing date.")
					.required("Required"),
				garage: Yup.number().required("Required").typeError("Please enter a value."),
				stories: Yup.number().required("Required").typeError("Please enter a value."),
				beds: Yup.number().required("Required").typeError("Please enter a value."),
				full_baths: Yup.number().required("Required").typeError("Please enter a value."),
				half_baths: Yup.number().required("Required").typeError("Please enter a value."),
				elevation: Yup.string().required("Required").typeError("Please enter a value."),
				traffic_source: Yup.number().required("Required").typeError("Please enter a value."),
			}
			if (_.get(settings, `enabled.contractBasePrices`)) {
				shape.floorplan_base_price = Yup.number()
					.min(100000, "Price must be at least $100,000.")
					.max(5000000, "Price must be below $5,000,000")
					.typeError("Please enter a valid base price.")
					.required("Required")
			}
			if (settings.requireContractZip) {
				shape.buyer_zip = Yup.string()
					.min(5, "Must be 5 characters")
					.max(5, "Must be 5 characters")
					.required("Required")
			}
			if (settings.additionalContractFields) {
				let all = []
				if (settings.additionalContractFields.global) {
					_.forEach(settings.additionalContractFields.global, (v) => {
						if (v.required) all.push(v)
					})
				}
				if (settings.additionalContractFields.communitySpecific[this.props.data.property]) {
					_.forEach(settings.additionalContractFields.communitySpecific[this.props.data.property], (v) => {
						if (v.required) all.push(v)
					})
				}
				if (all.length > 0) {
					_.forEach(all, (v) => {
						// Special instances first, like 55 year old birthday, then move onto generic
						if (v.special) {
							if (v.special.numYears) {
								let ts = moment().subtract(v.special.numYears, "years").unix()
								// this is for 55+ age restriction
								shape[v.name] = Yup.number()
									.typeError("Please enter a valid date.")
									.max(ts, "Birthday does not fit requirements of community.")
							}
						} else if (v.type === "date") {
							shape[v.name] = Yup.number().required("Required").typeError("Please enter a valid date.")
						} else if (v.type == "string") {
							shape[v.name] = Yup.string().required("Required").typeError("Please enter a value.")
						}
					})
				}
			}
			// Need realtor data
			if (this.state.needRealtorData) {
				shape.realtor_phone = Yup.string().required("Required").typeError("Please enter a value.")
				shape.realtor_email = Yup.string().required("Required").typeError("Please enter a value.")
			}
			if (
				settings?.disabled?.realtorRequirement &&
				settings?.disabled?.realtorRequirement.includes(this.props.data.property)
			) {
			} else {
				shape.realtor_office = Yup.mixed().when("realtor_involved", {
					is: 1,
					then: Yup.number("Type in license number to choose a realtor from the list.")
						.positive("Type in license number to choose a realtor from the list.")
						.typeError("Please enter a value.")
						.required("Type in license number to choose a realtor from the list."),
					otherwise: Yup.string().nullable().notRequired(),
				})
				shape.realtor = Yup.mixed().when("realtor_involved", {
					is: 1,
					then: Yup.number("Type in license number to choose a realtor from the list.")
						.positive("Type in license number to choose a realtor from the list.")
						.typeError("Please enter a value.")
						.required("Type in license number to choose a realtor from the list."),
					otherwise: Yup.string().nullable().notRequired(),
				})
			}
			return Yup.object().shape(shape)
		}
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	brokerageCallback = (v) => {
		let state = _.cloneDeep(this.state)
		if (v.length == 1 && _.has(v, `[0].addl.offices`) && v[0].addl.offices.length > 0) {
			state.extraFields.brokerage.offices = _.map(v[0].addl.offices, (v, k) => {
				return { value: k, label: v }
			})
			state.extraFields.brokerage.offices.unshift({ value: -99, label: "Unknown" })
		}
		if (v.length == 1 && _.has(v, `[0].addl.teams`) && v[0].addl.teams.length > 0) {
			state.extraFields.brokerage.teams = _.map(v[0].addl.teams, (v, k) => {
				return { value: k, label: v }
			})
			state.extraFields.brokerage.teams.unshift({ value: -99, label: "Unknown" })
		}
		this.setState(state, () => {
			console.log(this.state)
		})
	}

	duplicateLicense = (val, f) => {
		if (f.values.realtor == val) {
			this.setState({ duplicateLicense: true })
		} else {
			this.setState({ duplicateLicense: false })
		}
	}

	realtorFields = (f) => {
		if (f.values.realtor_involved == 1) {
			let realtorRequirement = true
			if (
				settings?.disabled?.realtorRequirement &&
				settings?.disabled?.realtorRequirement.includes(this.props.data.property)
			) {
				realtorRequirement = false
			}
			return (
				<React.Fragment>
					<li className={fieldStatus("realtor", f)}>
						<label htmlFor="realtor">
							Realtor License Number{realtorRequirement ? <sup>*</sup> : ""}
							{/* <span
								className="text-xs ml-2 text-blue underline cursor-pointer font-bold"
								onClick={() => {
									this.setState({ trecModal: true })
								}}>
								License Lookup
							</span> */}
						</label>
						{f.errors.realtor && f.touched.realtor && (
							<div className="form__message">{f.errors.realtor}</div>
						)}
						<Typeahead
							name="realtor"
							className="form__input"
							value={f.values.realtor}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							touched={f.touched.realtor}
							error={f.errors.realtor}
							reversed={true}
							needRealtorData={(v) => {
								this.setState({ needRealtorData: v })
							}}
							ep="/typeaheadTrec"
						/>
					</li>
					<li className={fieldStatus("realtor_office", f)}>
						<label htmlFor="realtor_office">
							Brokerage License Number{realtorRequirement ? <sup>*</sup> : ""}
							<span
								className={classNames(`text-[11px] text-red-600`, {
									block: this.state.duplicateLicense,
									hidden: !this.state.duplicateLicense,
								})}>
								Duplicate Realtor and brokerage license detected. Please ensure this is the brokerage
								number.
							</span>
						</label>
						{f.errors.realtor_office && f.touched.realtor_office && (
							<div className="form__message">{f.errors.realtor_office}</div>
						)}
						<Typeahead
							name="realtor_office"
							className="form__input"
							value={f.values.realtor_office}
							onChange={(k, v) => {
								f.setFieldValue("realtor_office", v)
								this.duplicateLicense(v, f)
							}}
							onBlur={f.setFieldTouched}
							touched={f.touched.realtor_office}
							error={f.errors.realtor_office}
							reversed={true}
							ep="/typeaheadTrec"
							callback={this.brokerageCallback}
						/>
					</li>
					{this.state.needRealtorData ? (
						<>
							<li className={fieldStatus("realtor_phone", f)}>
								<label htmlFor="realtor_phone">
									Realtor Phone <sup>*</sup>
								</label>
								{f.errors.realtor_phone && f.touched.realtor_phone && (
									<div className="form__message">{f.errors.realtor_phone}</div>
								)}
								<NumberField
									name={`realtor_phone`}
									value={f.values.realtor_phone}
									format="+1 (###) ###-####"
									className="form__input"
									isNumericString
									onChange={(name, v) => {
										f.setFieldValue(`realtor_phone`, v)
									}}
									onBlur={() => f.setFieldTouched("realtor_phone", true)}
								/>
							</li>
							<li className={fieldStatus("realtor_email", f)}>
								<label htmlFor="realtor_email">
									Buyer Email<sup>*</sup>
								</label>
								{f.errors.realtor_email && f.touched.realtor_email && (
									<div className="form__message">{f.errors.realtor_email}</div>
								)}
								<Field name="realtor_email" type="email" className="form__input" />
							</li>
						</>
					) : null}
					{this.state.extraFields.brokerage.offices.length > 0 && (
						<li className={fieldStatus("realtor_office_office", f)}>
							<label htmlFor="realtor_office_office">Brokerage Office</label>
							{f.errors.realtor_office_office && f.touched.realtor_office_office && (
								<div className="form__message">{f.errors.realtor_office_office}</div>
							)}
							<ReactSelect
								name={`realtor_office_office`}
								options={this.state.extraFields.brokerage.offices}
								value={f.values.realtor_office_office}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
					)}
					{this.state.extraFields.brokerage.teams.length > 0 && (
						<li className={fieldStatus("realtor_office_team", f)}>
							<label htmlFor="realtor_office_team">Brokerage Team</label>
							{f.errors.realtor_office_team && f.touched.realtor_office_team && (
								<div className="form__message">{f.errors.realtor_office_team}</div>
							)}
							<ReactSelect
								name={`realtor_office_team`}
								options={this.state.extraFields.brokerage.teams}
								value={f.values.realtor_office_team}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
					)}
				</React.Fragment>
			)
		}
	}

	coFields = (f) => {
		if (f.values.has_co) {
			return (
				<React.Fragment>
					<li className={fieldStatus("co_first", f)}>
						<label htmlFor="co_first">
							Co-Buyer First Name<sup>*</sup>
						</label>
						{f.errors.co_first && f.touched.co_first && (
							<div className="form__message">{f.errors.co_first}</div>
						)}
						<Field name="co_first" type="text" className="form__input" />
					</li>
					<li className={fieldStatus("co_last", f)}>
						<label htmlFor="co_last">
							Co-Buyer Last Name<sup>*</sup>
						</label>
						{f.errors.co_last && f.touched.co_last && (
							<div className="form__message">{f.errors.co_last}</div>
						)}
						<Field name="co_last" type="text" className="form__input" />
					</li>
				</React.Fragment>
			)
		}
	}

	trafficSources = () => {
		return _.map(this.props.payload.public.trafficSources, (v) => {
			return { value: v.id, label: v.name }
		})
	}

	spOptions = () => {
		let user = currentUser()
		let sps = []
		let d = this.props.super ? this.props.data.lot : this.props.data
		_.forEach(this.props.payload.public.salespeople, (v) => {
			if (this.props.super || user.viewAs) {
				if (v.builders.includes(d.builder) && v.properties.includes(d.property)) {
					sps.push({
						label: `${v.first} ${v.last}`,
						value: v.id,
					})
				}
			} else {
				if (v.builders.includes(d.builder) && v.properties.includes(d.property) && v.status == 1) {
					sps.push({
						label: `${v.first} ${v.last}`,
						value: v.id,
					})
				}
			}
		})
		return sps
	}

	addlFields = (f) => {
		let all = []
		if (settings.additionalContractFields) {
			if (settings.additionalContractFields.global) {
				_.forEach(settings.additionalContractFields.global, (v) => {
					all.push(v)
				})
			}
			if (settings.additionalContractFields.communitySpecific[this.props.data.property]) {
				_.forEach(settings.additionalContractFields.communitySpecific[this.props.data.property], (v) => {
					all.push(v)
				})
			}
		}
		if (all.length === 0) return ""
		let ret = []
		_.forEach(all, (v) => {
			let r
			if (v.type === "date") {
				r = (
					<DateField
						name={v.name}
						className="form__input"
						value={f.values[v.name]}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						birthday={true}
					/>
				)
			}
			ret.push(
				<li className={fieldStatus(v.name, f)}>
					<label htmlFor={v.name}>
						{v.label}
						{v.required ? <sup>*</sup> : ""}
					</label>
					{f.errors[v.name] && f.touched[v.name] && <div className="form__message">{f.errors[v.name]}</div>}
					{r}
				</li>
			)
		})
		return ret
	}

	formLayout = (f) => {
		return (
			<div>
				{/* console.log(f) */}
				<Form>
					<ul className="form__list">
						<li className={fieldStatus("salesperson", f)}>
							<label htmlFor="salesperson">
								Salesperson<sup>*</sup>
							</label>
							{f.errors.salesperson && f.touched.salesperson && (
								<div className="form__message">{f.errors.salesperson}</div>
							)}
							<ReactSelect
								name={`salesperson`}
								options={this.spOptions()}
								value={f.values.salesperson}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
								clearable={true}
							/>
						</li>
						<li className={fieldStatus("primary_first", f)}>
							<label htmlFor="primary_first">
								Buyer First Name<sup>*</sup>
							</label>
							{f.errors.primary_first && f.touched.primary_first && (
								<div className="form__message">{f.errors.primary_first}</div>
							)}
							<Field name="primary_first" type="text" className="form__input" />
						</li>
						<li className={fieldStatus("primary_last", f)}>
							<label htmlFor="primary_last">
								Buyer Last Name<sup>*</sup>
							</label>
							{f.errors.primary_last && f.touched.primary_last && (
								<div className="form__message">{f.errors.primary_last}</div>
							)}
							<Field name="primary_last" type="text" className="form__input" />
						</li>
						{settings.requireSaleEmail && (
							<li className={fieldStatus("primary_email", f)}>
								<label htmlFor="primary_email">
									Buyer Email<sup>*</sup>
								</label>
								{f.errors.primary_email && f.touched.primary_email && (
									<div className="form__message">{f.errors.primary_email}</div>
								)}
								<Field name="primary_email" type="email" className="form__input" />
							</li>
						)}
						{(settings.requireContractZip || settings.optionalSaleZip) && (
							<li className={fieldStatus("buyer_zip", f)}>
								<label htmlFor="buyer_zip">
									Current Zip {settings.requireContractZip && <sup>*</sup>}
								</label>
								{f.errors.buyer_zip && f.touched.buyer_zip && (
									<div className="form__message">{f.errors.buyer_zip}</div>
								)}
								<Field name="buyer_zip" type="text" className="form__input" />
							</li>
						)}
						<li className={fieldStatus("has_co", f)}>
							<label htmlFor="has_co">Has Co-Buyer?</label>
							{f.errors.has_co && f.touched.has_co && (
								<div className="form__message">{f.errors.has_co}</div>
							)}
							<Field
								name="has_co"
								type="checkbox"
								className="form__input"
								onChange={(event) => f.setFieldValue("has_co", event.target.checked)}
								checked={f.values.has_co}
							/>
						</li>
						{this.coFields(f)}
						{_.get(settings, `enabled.contractBasePrices`) && (
							<li className={fieldStatus("floorplan_base_price", f)}>
								<label htmlFor="floorplan_base_price">
									Floorplan Base Price <sup>*</sup>
								</label>
								{f.errors.floorplan_base_price && f.touched.floorplan_base_price && (
									<div className="form__message">{f.errors.floorplan_base_price}</div>
								)}
								<NumberField
									name="floorplan_base_price"
									type="text"
									className="form__input"
									onChange={f.setFieldValue}
									onBlur={f.setFieldTouched}
									touched={f.touched.floorplan_base_price}
									error={f.errors.floorplan_base_price}
									value={f.values.floorplan_base_price}
									thousandSeparator={true}
									prefix="$"
								/>
							</li>
						)}
						<li className={fieldStatus("price", f)}>
							<label htmlFor="price">
								Contract Price <sup>*</sup>
							</label>
							{f.errors.price && f.touched.price && <div className="form__message">{f.errors.price}</div>}
							<NumberField
								name="price"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.price}
								error={f.errors.price}
								value={f.values.price}
								thousandSeparator={true}
								prefix="$"
							/>
						</li>
						<li className={fieldStatus("sale_date", f)}>
							<label htmlFor="sale_date">
								Contract Date <sup>*</sup>
							</label>
							{f.errors.sale_date && f.touched.sale_date && (
								<div className="form__message">{f.errors.sale_date}</div>
							)}
							<DateField
								name="sale_date"
								className="form__textarea"
								value={f.values.sale_date}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.sale_date}
								error={f.errors.sale_date}
								blockFuture={true}
							/>
						</li>
						<li className={fieldStatus("estimated_closing", f)}>
							<label htmlFor="estimated_closing">
								Estimated Closing <sup>*</sup>
							</label>
							{f.errors.estimated_closing && f.touched.estimated_closing && (
								<div className="form__message">{f.errors.estimated_closing}</div>
							)}
							<DateField
								name="estimated_closing"
								className="form__textarea"
								value={f.values.estimated_closing}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.estimated_closing}
								error={f.errors.estimated_closing}
							/>
						</li>
						{/* <li className={fieldStatus("event_id", f)}>
										<label htmlFor="event_id">Event</label>
										{f.errors.event_id && f.touched.event_id && (
											<div className="form__message">{f.errors.event_id}</div>
										)}
										<Typeahead
											name="event_id"
											className="form__input"
											value={f.values.event_id.value}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.event_id}
											error={f.errors.event_id}
											placeholder={f.values.label_address}
											ep="/typeaheadEvents"
										/>
									</li> */}
						<li className={fieldStatus("realtor_involved", f)}>
							<label htmlFor="realtor_involved">
								Realtor Involved? <sup>*</sup>
							</label>
							{f.errors.realtor_involved && f.touched.realtor_involved && (
								<div className="form__message">{f.errors.realtor_involved}</div>
							)}
							<ReactSelect
								name={`realtor_involved`}
								options={[
									{
										value: 0,
										label: "No",
									},
									{
										value: 1,
										label: "Yes",
									},
								]}
								value={f.values.realtor_involved}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
						{this.realtorFields(f)}
						<li className={fieldStatus("floorplan", f)}>
							<label htmlFor="floorplan">
								Floorplan <sup>*</sup>
							</label>
							{f.errors.floorplan && f.touched.floorplan && (
								<div className="form__message">{f.errors.floorplan}</div>
							)}
							<Typeahead
								name="floorplan"
								className="form__input"
								value={f.values.floorplan}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.floorplan}
								error={f.errors.floorplan}
								placeholder={f.values.floorplan_label}
								ep="/typeaheadFloorplans"
							/>
						</li>
						<li className={fieldStatus("elevation", f)}>
							<label htmlFor="elevation">
								Elevation<sup>*</sup>
							</label>
							{f.errors.elevation && f.touched.elevation && (
								<div className="form__message">{f.errors.elevation}</div>
							)}
							<Field name="elevation" type="text" className="form__input" />
						</li>
						<li className={fieldStatus("sqft", f)}>
							<label htmlFor="sqft">
								Square Feet<sup>*</sup>
							</label>
							{f.errors.sqft && f.touched.sqft && <div className="form__message">{f.errors.sqft}</div>}
							<NumberField
								name="sqft"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.sqft}
								error={f.errors.sqft}
								value={f.values.sqft}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("stories", f)}>
							<label htmlFor="stories">
								Stories<sup>*</sup>
							</label>
							{f.errors.stories && f.touched.stories && (
								<div className="form__message">{f.errors.stories}</div>
							)}
							<NumberField
								name="stories"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.stories}
								error={f.errors.stories}
								value={f.values.stories}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("beds", f)}>
							<label htmlFor="beds">
								Beds<sup>*</sup>
							</label>
							{f.errors.beds && f.touched.beds && <div className="form__message">{f.errors.beds}</div>}
							<NumberField
								name="beds"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.beds}
								error={f.errors.beds}
								value={f.values.beds}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("full_baths", f)}>
							<label htmlFor="full_baths">
								Full Baths<sup>*</sup>
							</label>
							{f.errors.full_baths && f.touched.full_baths && (
								<div className="form__message">{f.errors.full_baths}</div>
							)}
							<NumberField
								name="full_baths"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.full_baths}
								error={f.errors.full_baths}
								value={f.values.full_baths}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("half_baths", f)}>
							<label htmlFor="half_baths">
								Half Baths<sup>*</sup>
							</label>
							{f.errors.half_baths && f.touched.half_baths && (
								<div className="form__message">{f.errors.half_baths}</div>
							)}
							<NumberField
								name="half_baths"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.half_baths}
								error={f.errors.half_baths}
								value={f.values.half_baths}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("garage", f)}>
							<label htmlFor="garage">
								Garage<sup>*</sup>
							</label>
							{f.errors.garage && f.touched.garage && (
								<div className="form__message">{f.errors.garage}</div>
							)}
							<NumberField
								name="garage"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.garage}
								error={f.errors.garage}
								value={f.values.garage}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("traffic_source", f)}>
							<label htmlFor="traffic_source">
								Traffic Source <sup>*</sup>
							</label>
							{f.errors.traffic_source && f.touched.traffic_source && (
								<div className="form__message">{f.errors.traffic_source}</div>
							)}
							<ReactSelect
								name={`traffic_source`}
								options={this.trafficSources()}
								value={f.values.traffic_source}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
						{settings?.enabled?.trafficSourceDetails ? (
							<li className={fieldStatus("source_details", f)}>
								<label htmlFor="source_details">Traffic Source Details</label>
								{f.errors.source_details && f.touched.source_details && (
									<div className="form__message">{f.errors.source_details}</div>
								)}
								<Field name="source_details" type="text" className="form__input" />
							</li>
						) : null}
						<li className={fieldStatus("comments", f)}>
							<label htmlFor="comments">Comments/Notes</label>
							{f.errors.comments && f.touched.comments && (
								<div className="form__message">{f.errors.comments}</div>
							)}
							<TextArea
								name="comments"
								className="form__textarea"
								value={f.values.comments}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.comments}
								error={f.errors.comments}
							/>
						</li>
						{this.addlFields(f)}
					</ul>
					<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
				</Form>
			</div>
		)
	}

	render() {
		return (
			<div className="modal">
				<h3>Add Contract: {this.props.data.address}</h3>
				<Formik
					initialValues={this.state.fields}
					validateOnMount={true}
					validationSchema={this.validation}
					enableReinitialize
					onSubmit={(values) => {
						this.props.loadingStatus(true)
						// On the super side with adding this
						if (this.props.super) {
							values.lot_id = this.props.data.lot.id
						} else {
							// On the salesperson side
							values.lot_id = this.props.data.id
						}

						submitData("inputContract", values)
							.then((data) => {
								this.props.notify(data, this.props.name)
								this.props.loadingStatus(false)
							})
							.catch((e) => {
								this.props.notify(e, this.props.name)
								this.props.loadingStatus(false)
							})
					}}>
					{(f) => this.formLayout(f)}
				</Formik>
				<Modal
					classNames={{ modal: "modal__full" }}
					open={this.state.trecModal}
					onClose={() => this.setState({ trecModal: false })}
					center>
					<div className="">
						<div>
							<h3>License Lookup</h3>
							<Typeahead
								name="trec"
								className="form__input"
								value={this.state.trec}
								onChange={(name, v) => {
									this.setState({ license: v })
								}}
								ep="/typeaheadTrecName"
							/>
						</div>
						<div className=""></div>
					</div>
				</Modal>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(ContractModal)
